<template>
  <div class="publish_task_container">
    <div class="step_box">
      <el-steps :active="active" finish-status="success" process-status="finish" align-center>
        <el-step title="选择类型"></el-step>
        <el-step title="完善任务"></el-step>
        <el-step title="通用设置"></el-step>
        <el-step title="发布上线"></el-step>
      </el-steps>
    </div>
    <div class="step_form_container">
      <FirstStep
        v-if="active == 0"
        ref="firstStep"
        :firstStepForm="firstStepForm"
        :typeList="selectList"
        :rules="firstRules"
        @changeHotType="changeHotType"
        @handleSelect="handleSelect"
      >
        <div slot="handle">
        	<el-button type="primary" :loading="loading" @click="firstSubmit()">下一步</el-button>
        </div>
      </FirstStep>
      <SecondStep
        v-else-if="active == 1"
        ref="secondStep"
        :secondStepForm="secondStepForm"
        :typeList="selectList"
        :rules="secondRules"
        @changeTaskType="changeTaskType"
        @changeDuration="changeDuration"
        @toAddStep="toAddStep"
        @toDeleteStep="toDeleteStep"
        @needTextImage="needTextImage"
        @toAddStrip="toAddStrip"
        @toDeleteStrip="toDeleteStrip"
      >
        <div slot="handle">
        	<el-button type="primary" @click="lastStep()">上一步</el-button>
        	<el-button type="success" :loading="loading" @click="Preview(1)">预览</el-button>
        	<el-button type="warning" :loading="loading" @click="secondSubmit()">下一步</el-button>
        </div>
      </SecondStep>
      <ThirdStep 
        v-else-if="active == 2"
        ref="thirdStep"
        :thirdStepForm="thirdStepForm"
        :typeList="selectList"
        :guidePrice="guidePrice"
        :showPriceTip="showPriceTip"
        :priceTip="priceTip"
        :showTime="showTime"
        :rules="thirdRules"
        :timeChoose.sync="timeChoose"
        @changePrice="changePrice"
        @changeLaunch="changeLaunch"
        @changeDate="changeDate"
        @clearQuick="clearQuick"
        @changeNumber="changeNumber"
        @cityChange="cityChange"
      >
        <div slot="handle">
        	<el-button type="primary" @click="lastStep()">上一步</el-button>
        	<el-button type="success" :loading="loading" @click="Preview(2)">预览</el-button>
        	<el-button type="warning" :loading="loading" @click="thirddSubmit()">确认并发布</el-button>
        </div>
      </ThirdStep>
      <ForthStep
        v-else-if="active == 3 || active == 4"
        :orderInfo="orderInfo"
        :typeList="selectList"
        :readyPay="readyPay"
        :submitSuccess="submitSuccess"
      >
        <div slot="handle">
        	<el-button style="width: 150px;" type="primary" size="small" :loading="loading" @click="toPay">支付</el-button>
        </div>
        <template v-if="active == 4">
          <div slot="finished">
            <el-button type="primary" @click="gotoTaskDetail">查看任务详情</el-button>
            <el-button @click="goBack">返回</el-button>
          </div>
        </template>
      </ForthStep>
    </div>
    <el-dialog title="手机预览" :visible="dialogTableVisible" @close="closePreview" width="850px">
      <mobile-preview v-if="dialogTableVisible" :isStep="true" :formData="formData"></mobile-preview>
    </el-dialog>
  </div>
</template>

<script>
  import "@/shared/plugins/element"
  import { mapState } from "vuex";
  import { getToken } from '@/shared/utils/auth.js'
  import FirstStep from '../publishComponents/firstStep.vue'
  import SecondStep from '../publishComponents/secondStep.vue'
  import ThirdStep from '../publishComponents/thirdStep.vue'
  import ForthStep from '../publishComponents/forthStep.vue'
  import Api from "@/api";
  import MobilePreview from './mobilePreview.vue'
  export default {
    name: "publishTask",
    components:{
      FirstStep,
      SecondStep,
      ThirdStep,
      ForthStep,
      MobilePreview
    },
    filters:{
      
    },
    data(){
      return {
        active:0,//步骤激活状态
        typeList:[],//总类型数据
        type:1,//选择热门类型还是其他类型
        selectList:{
          hotTypeList:[],//热门类型选择数据
          otherTypeList:[],//其他类型选择数据
          durationList:[],//任务时长数据
          taskTypeList:[],//任务类型
          contactsList:[],//联系方式
          launchList:[],//投放类型
          deviceLimit:[],//设备限制
          cityList:[],//投放城市
          payTypeList:[],//支付方式
        },//类型
        firstStepForm: {
          id:'',
          task_step:1,//发布步骤 
          company_userid:'',//公司id
          company_name:'',//公司名
          company_logo:'',//公司logo
          task_species_id:1,//任务种类id
          task_species_name:'',//任务名称
          other_id:'',//其他类型id
          other_name:'',//其他类型
        },
        secondStepForm:{
          id:'',//任务id
          task_step:2,//发布步骤 
          task_title:'',//任务标题
          task_type:1,//任务类型
          task_time:1,//任务时长
          task_desc:'',//任务描述
          task_step_guide:[
            {
              desc:'',
              url:'',
              isText:false,
              isImage:false,
              images:[],
              rules:[]
            }
          ],
        },
        thirdStepForm:{
          cityArr:[],
          date:'',
          id:'',//任务id
          task_step:3,//发布步骤 
          amount:'',//数量
          price:'',//单价单位分
          prepayments:0,//预支付 单位分
          contract_type:1,//联系人类型
          contract:'',//联系方式
          agreed:false,//是否同意协议 1或0
          settlement_info:'',//结算说明
          country_id:'',//国家id
          province_id:'',//省id
          city_id:'',//城市id
          dist_id:'',//区id
          online_type:1,//投放时长
          online_start_time:'',//开始时间
          online_end_time:'',//结束时间
          device_limit:1,//设备限制
          scope:'',
        },
        showTime:false,//定期投放显示选择时间框
        guidePrice:'',//指导价格
        minPrice:null,//最小价格
        maxPrice:null,//最大价格
        showPriceTip:false,//是否显示输入任务单价错误提示
        priceTip:'',//任务单价错误提示语
        formId:'',//任务id
        loading:false,//操作状态
        firstRules:{
          company_name:[
            { trigger: 'blur', message: '请填写任务名称',required:true }
          ],
          task_species_id:[
            { trigger: 'change', message: '请选择热门类型',required:true }
          ]
        },
        secondRules:{
          task_title:[
            { trigger: 'blur', message: '请填写任务名称',required:true }
          ],
          task_desc:[
            { trigger: 'blur', message: '请填写任务介绍',required:true }
          ],
          task_type:[
            { trigger: 'change', message: '请选择任务类型',required:true }
          ],
          task_time:[
            { trigger: 'change', message: '请选择任务时长',required:true }
          ]
        },
        thirdRules:{
          price:[
            { trigger: 'blur', message: '请填写任务单价',required:true }
          ],
          amount:[
            { pattern:/^[1-9]\d{1,}$/,trigger: 'blur', message: '请正确填写任务名额',required:true }
          ],
          contract_type:[
            { trigger: 'change', message: '请选择联系人类型',required:true }
          ],
          contract:[
            { trigger: 'blur', message: '请填写联系方式',required:true }
          ],
          settlement_info:[
            { trigger: 'blur', message: '请填写结算说明',required:true }
          ],
        },
        orderInfo:{},//订单信息
        timeChoose:1,//选择时间类型 1一周 2 两周 3 一个月
        readyPay:true,//是否显示订单支付剩余时间
        submitSuccess:false,//赚钱任务是否失效
        dialogTableVisible:false,//预览可见状态
        formData:{}//预览数据
      }
    },
    created() {
      if(JSON.stringify(this.orderInfo) == '{}' && this.active == 3){
        let value = sessionStorage.getItem("orderInfo");
        console.log(value)
        this.orderInfo = JSON.parse(value)
      }
    },
    mounted() {
      this.requestCommon();
      this.getCityList();
    },
    methods:{
      //获取基础类型
      async requestCommon(){
        try{
          let data = await Api.post.getCommon(getToken('token'));
          this.typeList = data.species;
          this.selectList.hotTypeList = data.species.filter( item => item.is_hot == 1 );
          this.selectList.otherTypeList = data.species.filter( item => item.is_hot == 0 );
          if(!this.$route.query.id){
            let obj = {
              id:this.firstStepForm.task_species_id,
              type:this.type
            }
            this.setPriceNumber(obj);
          }
          this.selectList.durationList = data.taskTime;
          this.selectList.taskTypeList = data.taskType;
          this.selectList.contactsList = data.contractType;
          this.selectList.launchList = data.onlineType;
          this.selectList.deviceLimit = data.deviceLimit;
          this.selectList.payTypeList = data.payType;
          if(this.$route.query.id){
            this.getTaskDetail(this.$route.query.id)
          }
        }catch(e){
          //TODO handle the exception
        }
      },
      //获取城市列表
      async getCityList(){
        try{
          let data = await Api.post.getCity();
          this.selectList.cityList = data.tree;
        }catch(e){
          //TODO handle the exception
        }
      },
      //获取详情
      async getTaskDetail(id){
        try{
          let params = {
            id:id
          }
          let res = await Api.post.getTask(params);
          //设置第一步表单初始值
          this.firstStepForm = {
            id:id,
            task_step:1,//发布步骤 
            company_userid:res.company_userid,//公司id
            company_name:res.company_name,//公司名
            company_logo:res.company_logo,//公司logo
            task_species_id:res.task_species_id,//任务种类id
            task_species_name:res.task_species_name,//任务名称
            other_id:'',//其他类型id
            other_name:'',//其他类型
          }
          console.log(this.firstStepForm,1111)
          //设置第二步表单初始值
          this.secondStepForm = {
            id:id,//任务id
            task_step:2,//发布步骤 
            task_title:res.task_title,//任务标题
            task_type:res.task_type,//任务类型
            task_time:res.task_time,//任务时长
            task_desc:res.task_desc,//任务描述
            task_step_guide:[],
          }
          console.log(this.secondStepForm,2222)
          //设置第三步表单初始值
          this.thirdStepForm = {
            date:'',
            id:id,//任务id
            task_step:3,//发布步骤 
            amount:res.amount,//数量
            price:res.price/100,//单价单位分
            prepayments:res.prepayments/100,//预支付 单位分
            contract_type:res.contract_type,//联系人类型
            contract:res.contract,//联系方式
            agreed:res.agreed == 0 ? false : true,//是否同意协议 1或0
            settlement_info:res.settlement_info,//结算说明
            country_id:res.country_id,//国家id
            province_id:res.province_id,//省id
            city_id:res.city_id,//城市id
            dist_id:res.dist_id,//区id
            online_type:res.online_type,//投放时长
            online_start_time:res.online_start_time,//开始时间
            online_end_time:res.online_end_time,//结束时间
            device_limit:res.device_limit,//设备限制
            scope:res.scope,//城市名称
            cityArr:[res.province_id.toString(),res.city_id.toString()]
          }
          //根据任务种类id。判断是否是热门选项
          this.$nextTick(()=>{
            let hot;
            this.selectList.hotTypeList.forEach(item => {
              if(item.id == this.firstStepForm.task_species_id){
                hot = item.isHot
              }
            })
            //根据是否是热门类型来重置其他类型id，并设置指导价格
            hot == 1 ? this.type == 1 : this.type == 2;
            let obj = {
              id:this.firstStepForm.task_species_id,
              type:this.type
            }
            console.log(this.thirdStepForm,123)
            this.setPriceNumber(obj);
            //后台返回的步骤里。布尔类型变成了字符串。进行重置
            res.task_step_guide_data.forEach(item=>{
              if(!item.rules){
                item.rules = []; 
              }
              item.isImage == 'false' ? item.isImage = false : item.isImage = true ;
              item.isText == 'false' ? item.isText = false : item.isText = true ;
            })
            this.secondStepForm.task_step_guide = [...res.task_step_guide_data]
            if(this.thirdStepForm.online_start_time != ''){
              let usedTime = new Date(this.thirdStepForm.online_end_time) - new Date(this.thirdStepForm.online_start_time);
              let days = Math.floor(usedTime / (24 * 3600 * 1000));
              if(days == 7 || days == 14 || days == 30){
                this.changeLaunch(this.thirdStepForm.online_type)
              }
              if(days == 7){
                this.timeChoose = 1
              }else if(days == 14){
                this.timeChoose = 2
              }else if(days == 30){
                this.timeChoose = 3
              }else{
                this.timeChoose = 0
              }
            }
          })
        }catch(e){
          //TODO handle the exception
        }
      },
      //选择公司
      handleSelect(item){
        if(item.id){
          this.firstStepForm.company_userid = item.magellan_company_id;
          this.firstStepForm.company_name = item.name;
          this.firstStepForm.company_logo = item.logo;
        }
      },
      //上一步
      lastStep(){
        this.$nextTick(()=>{
          if (this.active-- < 0) this.active = 0;
        })
      },
      //第一步 选择类型 改变热门类型，关联指导价格
      changeHotType(obj){
        this.setPriceNumber(obj)
      },
      //第一步 提交
      async firstSubmit() {
        this.loading = true;
        if(this.type == 2){
          this.firstStepForm.task_species_id = this.firstStepForm.other_id;
        }
        let form = {...this.firstStepForm}
        console.log(form)
        let flag = await this.$refs.firstStep.submitForm();
        if(flag){
          try{
            let res = await Api.post.postTask(form);
            this.formId = res.id;
            this.loading = false;
            if (this.active++ > 3) this.active = 3;
          }catch(e){
            this.loading = false;
            //TODO handle the exception
          }
        }else{
          this.loading = false;
        }
        
      },
      //第二步 完善任务 更改任务类型
      changeTaskType(id){
        
      },
      //第二步 完善任务 更改任务时长
      changeDuration(id){
        
      },
      //添加步骤
      toAddStep(index){
        let obj = {
          desc:'',
          url:'',
          images:[],
          isText:false,
          isImage:false,
          rules:[]
        };
        this.secondStepForm.task_step_guide.push(obj);
      },
      //删除步骤
      toDeleteStep(stepIndex){
        if(this.secondStepForm.task_step_guide.length == 1){
          this.$confirm('步骤引导为必填项，当前只有一个步骤了，确定要删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.deleteStep(stepIndex)
          }).catch(() => {
                     
          });
        }else{
          this.deleteStep(stepIndex)
        }
        
      },
      //删除
      deleteStep(stepIndex){
        this.secondStepForm.task_step_guide.forEach((item,index) =>{
          if(index == stepIndex){
            this.secondStepForm.task_step_guide.splice(index,1);
          }
        })
      },
      //添加步骤 (选择用户需要提交规定的文字/图片)
      needTextImage(obj){
        this.secondStepForm.task_step_guide.forEach((item,index) =>{
          if(index == obj.index){
            if(obj.val){
              let params = {
                type:obj.type,
                img:[],
                text:''
              }
              item.rules.push(params);
            }else{
              item.rules.forEach((rule,i) =>{
                if(rule.type == obj.type){
                  item.rules.splice(i,1)
                }
              })
            }
          }
        })
        console.log(this.secondStepForm.task_step_guide)
      },
      //添加步骤 (选择用户需要提交规定的文字)---添加条目
      toAddStrip(obj){
        this.secondStepForm.task_step_guide.forEach((item,index) =>{
          if(index == obj.index){
            let params = {
              type:obj.type,
              img:[],
              text:''
            }
            item.rules.push(params);
          }
        })
      },
      //添加步骤 (选择用户需要提交规定的文字/图片)---删除条目
      toDeleteStrip(obj){
        this.secondStepForm.task_step_guide.forEach((item,index) =>{
          if(index == obj.index){
            item.rules.forEach((text,t)=>{
              if(obj.textIndex == t && text.type == obj.type){
                item.rules.splice(t,1);
                if(item.rules.length == 0){
                  item.isText = false
                  item.isImage = false
                }else{
                  let text = item.rules.some(item=>item.type == 1)
                  if(text){
                    item.isText = true
                  }else{
                    item.isText = false
                  }
                  let img = item.rules.some(item=>item.type == 2)
                  if(img){
                    item.isImage = true
                  }else{
                    item.isImage = false
                  }
                }
              }
            })
          }
        })
      },
      //第二步 提交
      async secondSubmit(){
        this.loading = true;
        let form = {...this.secondStepForm}
        form.id = this.formId;
        if(form.task_step_guide.length == 0){
          this.$message({
            message: '请编辑任务步骤！',
            type: 'warning'
          });
          this.loading = false;
        }else{
          let flag = await this.$refs.secondStep.submitForm();
          if(flag){
            try{
              let res = await Api.post.postTask(form);
              this.formId = res.id;
              this.loading = false;
              if (this.active++ > 3) this.active = 3;
            }catch(e){
              this.loading = false;
            }
          }else{
            this.loading = false;
          }
        }
      },
      //第三步 通用设置 填写指导价截取字符串
      getCaption(obj,state) {
        var index = obj.lastIndexOf("\~");
        if(state == 0){
          obj = obj.substring( 0, index );
        }else {
          obj = obj.substring( index + 1 , obj.length );
        }
        return obj;
      },
      //第三步 获取最小/大价格
      setPriceNumber(obj){
        this.type = obj.type
        let tempList = this.typeList.filter( item => item.id === obj.id );
        if(tempList.length > 0){
          this.firstStepForm.task_species_name = tempList[0].species_name;
          this.guidePrice = tempList[0].guide_price.replace('-','~');
          this.minPrice = Number(this.getCaption(this.guidePrice,0))
          this.maxPrice = Number(this.getCaption(this.guidePrice,1));
        }
        if(obj.type == 1){
          this.firstStepForm.task_species_id = obj.id;
          this.firstStepForm.other_id = '';
        }else{
          this.firstStepForm.task_species_id = '';
          this.firstStepForm.other_id = obj.id;
        }
      },
      //第三步 输入任务单价，限制在指导价价格范围内
      changePrice(val){
        if(this.thirdStepForm.amount == '' || this.thirdStepForm.price == ''){
          this.thirdStepForm.prepayments = 0
        }
        if(!val){
          this.showPriceTip = true;
          this.priceTip = '任务单价不能为空'
        }else{
          if( val >= this.minPrice && val <= this.maxPrice){
            this.showPriceTip = false;
            this.priceTip = '任务单价不能为空'
          }else{
            this.showPriceTip = true;
            this.priceTip = '请输入指导价数值之内的价格'
          }
          this.thirdStepForm.prepayments = this.multiplicate(this.thirdStepForm.price,this.thirdStepForm.amount)
        }
      },
      //精度乘法
      multiplicate(arg1,arg2){
        var m = 0,s1 = arg1.toString(),s2 = arg2.toString();
        try{
          m += s1.split(".")[1].length
        }catch(e){}
        try{
          m += s2.split(".")[1].length
        }catch(e){}
        return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
      },
      //根据数量和单价计算待支付金额
      changeNumber(val){
        if(val){
          if(this.thirdStepForm.price == ''){
            this.$message({
              message: '请先填写任务单价！',
              type: 'warning'
            });
          }else{
            this.thirdStepForm.prepayments = this.multiplicate(this.thirdStepForm.price,this.thirdStepForm.amount)
          }
        }
      },
      
      //第三步 选择投放时长
      changeLaunch(val){
        val == 2 ? this.showTime = true : this.showTime = false;
        if(val == 1){
          this.thirdStepForm.date = '';
          this.thirdStepForm.online_start_time = '';
          this.thirdStepForm.online_end_time = '';
        }else{
          let date = this.fun_date(7);
          this.timeChoose = 1;
          this.thirdStepForm.date = date;
          this.thirdStepForm.online_start_time = date[0]
          this.thirdStepForm.online_end_time = date[1]
        }
      },
      //计算时长
      fun_date(num) { 
        var date1 = new Date();
        //今天时间
        var time1 = date1.getFullYear() + "-" + (date1.getMonth() + 1) + "-" + date1.getDate()
        var date2 = new Date(date1);
         date2.setDate(date1.getDate() + num);
         //num是正数表示之后的时间，num负数表示之前的时间，0表示今天
         var time2 = date2.getFullYear() + "-" + (date2.getMonth() + 1) + "-" + date2.getDate(); 
        return [time1,time2];
      },
      //第三步 选择时间段
      changeDate(val){
        let date = [];
        if(val == 1){
          date= this.fun_date(7);
        }else if(val == 2){
          date = this.fun_date(14);
        }else if(val == 3){
          date = this.fun_date(30);
        }
        this.thirdStepForm.date = date;
        this.thirdStepForm.online_start_time = date[0]
        this.thirdStepForm.online_end_time = date[1]
      },
      //时间选择器
      clearQuick(val){
        this.timeChoose = 0;
        this.thirdStepForm.online_start_time = val[0]
        this.thirdStepForm.online_end_time = val[1]
      },
      //选择投递范围
      cityChange(obj){
        this.thirdStepForm.cityArr = obj.val;
        this.thirdStepForm.province_id = obj.val[0];
        this.thirdStepForm.city_id = obj.val[1];
        this.thirdStepForm.country_id = '100000',
        this.thirdStepForm.scope = '中国'+'-'+obj.area[0]+'-'+obj.area[1]
      },
      //第三步 提交
      async thirddSubmit(){
        this.loading = true;
        let form = {...this.thirdStepForm}
        form.id = this.formId;
        form.price = Number(form.price) * 100
        form.prepayments = Number(form.prepayments) * 100;
        form.agreed ? form.agreed = 1 : form.agreed = 0;
        if(form.agreed == 1){
          let flag = await this.$refs.thirdStep.submitForm();
          if(flag){
            try{
              let res = await Api.post.postTask(form);
              this.formId = res.id;
              sessionStorage.setItem("orderInfo",JSON.stringify(res.orderInfo));
              this.orderInfo = res.orderInfo;
              this.loading = false;
              if (this.active++ > 3) this.active = 3;
            }catch(e){
              this.loading = false;
            }
          }else{
            this.loading = false;
          }
        }else{
          this.$message({
            message: '请先阅读并同意--罗科仕兼职任务电子协议合同！',
            type: 'warning'
          });
          this.loading = false;
        }
        
      },
      //精度减法
      numSub(num1, num2) {
        var baseNum, baseNum1, baseNum2;
        var precision; // 精度 
        try {
            baseNum1 = num1.toString().split(".")[1].length;
        } catch (e) {
            baseNum1 = 0;
        }
        try {
            baseNum2 = num2.toString().split(".")[1].length;
        } catch (e) {
            baseNum2 = 0;
        }
        baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
        precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
        return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
      },
      //超时
      timeout(val){
        this.readyPay = val;
        this.submitSuccess = false
      },
      //支付
      async toPay(){
        let num = this.numSub(this.orderInfo.balance,this.orderInfo.total_fee/100);
        if(num >= 0){
          let form = {
            id : this.formId,
            task_step:4
          }
          try{
            let res = await Api.post.postTask(form);
            this.loading = false;
            this.submitSuccess = true;
            this.readyPay = false;
            this.formId = res.id;
            console.log(this.submitSuccess,this.readyPay)
            if (this.active++ > 3){
              this.active = 3;
            } 
            console.log(this.active)
          }catch(e){
            this.loading = false;
            this.submitSuccess = false;
            this.readyPay = true;
          }
        }else{
          this.loading = false;
          this.$message({
            message: '余额不足，请先充值或选择其他支付方式！',
            type: 'warning'
          });
        }
      },
      //查看详情
      gotoTaskDetail(){
        console.log(this.formId)
        let resolveDRoute = this.$router.resolve({
          path: `/money-task/detail/${this.formId }`,
        });
        window.open(resolveDRoute.href, "_blank");
      },
      //返回
      goBack(){
        this.$router.back(-1)
      },
      //手机预览
      Preview(step){
        this.dialogTableVisible = true;
        this.formData = {...this.firstStepForm,...this.secondStepForm,...this.thirdStepForm}
      },
      closePreview(){
        this.formData = {};
        this.dialogTableVisible = false;
      }
    }
  }
</script>

<style scoped="scoped">
  .publish_task_container{ overflow-x: auto;height: 100%; }
  .step_box{ width: 800px;margin: 0 auto 35px; }
  .step_form_container{ width: 600px; margin: 0 auto; }
</style>
